import Loading from '@@/core/components/shared/Loading/Loading'
import mixins from '@@/core/mixins/mixins'
import FormModal from "@@/core/libraries/form/FormModal";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";
import moment from 'moment-jalaali';
import {BButton, BCard, BCollapse, BFormGroup, BFormInput, BTable, BTooltip, VBToggle} from "bootstrap-vue";

export default {
  name: "HavaleCreate",
  components: {
    FormModal,
    Loading,
    BTooltip, BButton, BCollapse, BCard, BFormGroup, BFormInput, BTable,
    ProductSearch, 
  },
  directives: {
    'b-toggle': VBToggle,
  },
  mixins: [mixins],
  data() {
    return {
      productSelect: null,  
      stores: [],  
      sellers: [],  
      varietySelect: null,  
      destinationAgency: null,
      toStore: null,
      seller: null,
      fromStore: null,
      isButtonDisabled: false, 
      varieties: [],
    }
  },
  // computed: {
  //   agencies() {
  //     return this.$store.getters["admin/stores"];
  //   },
  // },
  mounted() {
    this.loadStores();
    this.loadSellers();
  },
  watch: {
  },
  methods: {
    async loadStores(){
        try {
            const response = await this.$axios.get("admin/stores");
            this.stores = response.data.data.stores;
            console.log(this.stores);
        } catch (e) {
            this.$root.notify(e);
        } 
    },  
    async loadSellers(){
        try {
            const response = await this.$axios.get("admin/sellers",{
              params: {
                all: 1 
              }
            });
            this.sellers = response.data.data.sellers;
        } catch (e) {
            this.$root.notify(e);
        } 
    },  
    barcodeVarieties() {  
      const routeData = this.$router.resolve({  
        path: '/admin/havale-barcodes',  
        query: {  
          varieties: JSON.stringify(this.varieties)  
        }  
      });  
      window.open(routeData.href, '_blank');  
    },    
    printVarieties() {  
      const route = this.$router.resolve({  
        path: '/admin/havale-print',  
        query: {  
          varieties: JSON.stringify(this.varieties)  
        }  
      });  
      window.open(window.location.origin + route.href, '_blank');  
    },  
    clearVarieties() {  
      this.varieties = [];  
    },  
    selectTheProduct(p) {  
      this.productSelect = p;  
    },  
    selectedVariety(item) {
      this.varietySelect = item; 
    },  
    addVariety() {  
        if (this.varietySelect) {  
          const exists = this.varieties.some(variety => variety.id === this.varietySelect.id);  
          if (exists) {  
              this.$root.notify(
                "این تنوع تکراری است.",
                "warning"
              );
              return;
          }  
          this.varieties.push({  
              ...this.varietySelect,  
              created_at: moment().format('jYYYY/jM/jD ساعت HH:mm:ss'),
              product_title: this.productSelect.title,
              seller_name: this.seller.full_name,
              from_store_name: this.fromStore.name,   
              to_store_name: this.toStore.name,   
          });  
          this.varietySelect = null;
          $('#add-variety-modal').modal('hide');
        } 
    },  
    deleteVariety(index) {  
      this.varieties.splice(index, 1);
    },  
    async submitData() {  
      const selectedFromStore = this.fromStore;
      const selectedToStore = this.toStore;

      const data = {  
        from_store_id: selectedFromStore.id,  
        to_store_id: selectedToStore.id,  
        transmitter_id: this.seller ? this.seller.id : '',  
        varieties: this.varieties.map(variety => ({  
          id: variety.id,  
          quantity: variety.agencyQuantity,  
        }))  
      };  

      try {  
        const response = await this.$axios.post('admin/stores/remittance',data);  
        this.$root.notify(response.data.message, 'success');
        this.isButtonDisabled = true;  
        console.log('Response:', response.data);  
      } catch (error) {  
        this.$root.notify(error)
      }  
    }  
  }
}
